export default __webpack_public_path__ + "74b32c12543568206313191ea844e886.firefox.png";